import styled, { css } from "styled-components";
import { CONSTANTS, parseCSS } from "scripts/FunctionsBundle";
import { useParams } from "react-router";
import { useRef } from "react";

// ################################ INTERFACES & PROPS ################################

type _Base = import("utils/class-types").Base;
// ProjectScreen => Rename all instances to use
type ProjectScreenProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################

const _ProjectScreen = (props: ProjectScreenProps) => {
  const { projectid } = useParams();
  const ref = useRef<HTMLIFrameElement | null>(null);

  return (
    <div className={props.className}>
      <div className="controls">
        <button
          className="link-1 primary subtitle-1"
          onClick={() => {
            if (!ref.current) return;
            ref.current.requestFullscreen();
          }}
        >
          Fullscreen
        </button>

        <a
          href={CONSTANTS._URLS[projectid || "bingo"]}
          className="link-2 primary subtitle-1"
          target="_blank"
          rel="noreferrer"
        >
          Open original
        </a>
      </div>
      <iframe
        src={CONSTANTS._URLS[projectid || "bingo"]}
        ref={ref}
        title="project view"
        allowFullScreen={true}
      ></iframe>
    </div>
  );
};

// ################################ STYLES ################################
const ProjectScreen = styled(_ProjectScreen).attrs(
  (props): ProjectScreenProps => {
    return { ...props };
  }
)`
  ${(props) => css`
    .controls {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
    }

    iframe {
      width: 100%;
      height: 100svh;
      border: 0;
      margin: 2rem 0;
    }

    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################

export default ProjectScreen;
